<template>
    <aside class="snackbars">
        <transition name="snackbar" mode="out-in">
            <article v-if="snackbar" class="lc-snackbar snackbar" :key="snackbar.index">
                <p class="snackbar__message">{{ snackbar.message }}</p>
                <a v-if="snackbar.undo" @click.prevent="undo()" href="#" class="snackbar__action">Undo</a>
                <a @click.prevent="pop()" href="#" class="icon-button icon-button--large">
                    <icon type="close" color="dark"></icon>
                </a>
            </article>
        </transition>
    </aside>
</template>

<script>
import Icon from './Icon'

export default {
    props: {
        initialSnackbar: {
            required: false
        }
    },

    data () {
        return {
            queue: [],
            queueIndex: 0,
            timer: null,
            timeout: 8000
        }
    },

    created () {
        EventBus.$on('newSnackbar', (message, undo) => {
            this.add(message, undo)
        })
    },

    mounted () {
        if (this.initialSnackbar) {
            this.add(this.initialSnackbar.message)
        }
    },

    methods: {
        add (message, undo) {
            let snackbar = {
                index: this.queueIndex += 1,
                message
            }

            if (undo) {
                snackbar.undo = undo
            }

            this.queue.push(snackbar)

            this.startTimer()
        },

        startTimer () {
            if (!this.timer) {
                this.timer = setTimeout(this.pop, this.timeout)
            }
        },

        pop () {
            this.queue.shift()
            this.timer = clearTimeout(this.timer)

            if (this.snackbar) {
                this.startTimer()
            }
        },

        undo () {
            this.snackbar.undo()

            this.$nextTick(() => {
                this.pop()
            })
        }
    },

    computed: {
        snackbar () {
            return this.queue[0]
        }
    },

    components: {
        Icon
    }
}
</script>
